import axios from "axios";

export const URL = window.location.href.includes("dev")
  ? process.env.REACT_APP_API_URL
  : process.env.REACT_APP_API;

export const fetchProducts = async (categoryCode = null) => {
  let allProducts = [];
  let page = 1;
  let hasMore = true;

  try {
    while (hasMore) {
      const query = categoryCode
        ? `${URL}api/catalog?page=${page}&category_code=${categoryCode}`
        : `${URL}api/catalog?page=${page}`;

      const response = await axios.get(query);
      const { data, last_page } = response.data;

      allProducts = [...allProducts, ...data];

      if (page >= last_page) {
        hasMore = false;
      } else {
        page++;
      }
    }

    return { data: allProducts };
  } catch (error) {
    console.error("Failed to fetch products:", error);
    return { data: [] };
  }
};
